/**
 * TipoPessoaRecebedor
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {TipoPessoaRecebedorCollection} from '@/model/collection/TipoPessoaRecebedorCollection'

/* TODO: review generated class */
export class TipoPessoaRecebedor extends Resource {
  idTipoPessoaPk: number = 0

  nome: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idTipoPessoaPk
  }
  set $id(val) {
    this.idTipoPessoaPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  /**
   * Gets a instance of a given ID of TipoPessoaRecebedor
   */
  async getTipoPessoaRecebedor(id: number) {
    return await Request.get(`/admin/tipo-pessoa-recebedor/${id}`)
      .name('getTipoPessoaRecebedor')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of TipoPessoaRecebedor
   */
  async removeTipoPessoaRecebedor() {
    return await Request.delete(`/admin/tipo-pessoa-recebedor/${this.$id}`)
      .name('removeTipoPessoaRecebedor')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of TipoPessoaRecebedor
   */
  static async listTipoPessoaRecebedor(params: any) {
    return await Request.get(`/admin/tipo-pessoa-recebedor`, {params})
      .name('listTipoPessoaRecebedor')
      .as(TipoPessoaRecebedorCollection)
      .getData()
  }

  /**
   * Persists a new instance of TipoPessoaRecebedor. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistTipoPessoaRecebedor() {
    return await Request.post(`/admin/tipo-pessoa-recebedor`, this)
      .name('persistTipoPessoaRecebedor')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of TipoPessoaRecebedor to use it in a CSV file
   */
  static async listCsvTipoPessoaRecebedor(params: any) {
    return await Request.get(`/admin/tipo-pessoa-recebedor/csv`, {params})
      .name('listCsvTipoPessoaRecebedor')
      .as(TipoPessoaRecebedorCollection)
      .getData()
  }
}
